import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, Switch, Input, Row, Col, Spin } from 'antd'
import {changeNowNotificationRequest} from "../../redux/Ekko/actions"

class SettingsNotifications extends React.Component {
    constructor(props) {
        super(props)
    }

    onSwitchChange = (value) => {
        const { changeNowNotificationRequest } = this.props
        changeNowNotificationRequest(value)
    }

    render() {
        return (
            <Card title="Notifications settings">
                <Spin spinning={this.props.loadingCurrentApp} delay={100}>
                    <Row type="flex" justify="space-between" align="middle">
                        <h2>Notifications</h2>
                        <Switch checked={this.props.currentApplication.now_settings.notification} onChange={this.onSwitchChange}/>
                    </Row>
                    <Row>
                        <Col sm={18} xs={24}>
                            <p>
                                Click the toggle button to enable notifications for your users.
                            </p>
                        </Col>
                    </Row>
                </Spin>
            </Card>
        )
    }
}

const mapStateToProps = ({ ekko }) => ({
    currentApplication: ekko.currentApp,
    loadingCurrentApp: ekko.loadingCurrentApp
})

const mapActionsToProps = dispatch => ({
    changeNowNotificationRequest: bindActionCreators(changeNowNotificationRequest, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(SettingsNotifications)
